import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
// Actions
import {
  clearRedux,
  searchModules,
  getRole,
  createRole,
  updateRole
} from "Redux/actions";
// Core
import { Grid, Box } from "@mui/material";
// Components
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { Button, Form, Input } from "Components";
import { NotificationManager } from "Components/Notifications";
import Modules from "../modules";
import SubModules from "../subModules";
import Supervisor from "../modules/supervisor";
import moment from "moment";
import { useSupervisorPermission } from "../../../../../.common/utils/supervisorPermission";

const CreditEditRol = (props) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();

  // Props
  const { onShow, onClose, role, changeRoleCustom, hideSupervisor = false } = props;

  // Ref
  const formRef = useRef();

  // Local state
  const [showModalCrud, setShowModalCrud] = useState(false);
  const [showModalSubModules, setShowModalSubModules] = useState(false);
  const [moduleSelected, setModuleSelected] = useState(null);
  const [tabSelected, setTabSelected] = useState(0);
  const [modulesForCategory, setModulesForCategory] = useState(null);
  const [formData, setFormData] = useState({});
  const [isSupervisor, setIsSupervisor] = useState(false)
  const [isHideSupervisor, setIsHideSupervisor] = useState(hideSupervisor || false)

  // State manager
  const {
    loading: loadingModule,
    allfilters,
    categories: categoriesModules,
  } = useSelector((state) => state.moduleRedux);
  const {
    loadingCurrentSubUser,
    currentSubUser
  } = useSelector(
      (state) => state.subUserRedux
  );

  const { loading, loadingGetRole, loadedRecord, roleSelected } = useSelector(
    (state) => state.roleRedux
  );

  const { user } = useSelector((state) => state.securityRedux);
  const { subUserSelected, loadingSubUser } = useSelector(state => state.subUserRedux);


  const modulesCheck = (modules, role) => {
    modules.forEach((module) => {
      let moduleCheck = role.modules.filter(
        (moduleRol) => moduleRol.id === module.id
      );
      if (moduleCheck.length) {
        module.checked = true;
      } else {
        // The Map module should always be on by default (UserCode = 0)
        if (module.userCode !== 0) {
          module.checked = false;
        }
      }
      //Change subModules seleted by role
      module.subModules?.forEach((subModule) => {
        let subModulesCheck = moduleCheck[0]?.subModules?.filter(
          (subModuleRole) => subModuleRole.id === subModule.id
        ).length;
        if (subModulesCheck) {
          subModule.checked = true;
        } else {
          // When editing an existing role, if the subModule is not in the saved role,
          // it should be unchecked (the user explicitly removed it or it was never added)
          subModule.checked = false;
        }
      });
    });

    return modules;
  };

  const filterModules = (role) => {
    if (role) {
      //Change modules seleted by role
      let modules = {
        permission: modulesCheck(categoriesModules.permission, role),
        report: modulesCheck(categoriesModules.report, role),
        alert: modulesCheck(categoriesModules.alert, role),
      };
      setModulesForCategory(modules);
    } else {
      setModulesForCategory(categoriesModules);
    }
  };

  const switchModals = () => {
    setShowModalCrud(!showModalCrud);
    setShowModalSubModules(!showModalSubModules);
  };

  const consolidateIdModulesChecked = (modules) => {
    let result = [];
    modules.forEach((module) => {
      if (module.checked) result.push(module.id);
      module.subModules?.forEach((subModule) => {
        if (subModule.checked) result.push(subModule.id);
      });
    });
    return result;
  };

  const filterCheckedModulesRoleCustom = (modules) => {
    let result = [];
    result = modules.filter((module) => {
      if (module.checked) {
        module.subModules = module.subModules?.filter(
          (subModule) => subModule.checked
        );
        return module;
      }
    });
    return result;
  };

  const onCloseCustomRole = () => {
    let modules = filterCheckedModulesRoleCustom([
      ...modulesForCategory.permission,
      ...modulesForCategory.report,
    ]);
    let result = {
      ...changeRoleCustom,
      modules,
      isSupervisor
    };
    onClose(result);
  };

  const consolidateData = () => {
    let modules = consolidateIdModulesChecked([
      ...modulesForCategory.permission,
      ...modulesForCategory.report,
      // ...modulesForCategory.alert
    ]);

    let result = {
      name: formData.name,
      modules,
      isSupervisor
    };

    if (roleSelected) {
      result = {
        ...result,
        id: roleSelected.id,
      };
      dispatch(updateRole(result));
    } else {
      dispatch(createRole(result));
    }
  };

  const handleClose = () => {
    dispatch(
      clearRedux("ROLE", {
        roleSelected: null,
      })
    );
    onClose();
  };

  useEffect(() => {
    dispatch(searchModules(allfilters));
  }, []);

  useEffect(() => {
    if (loadedRecord) {
      NotificationManager.success(
        roleSelected
          ? messages[`role_editMessage`]
          : messages[`role_createMessage`],
        messages["success"],
        3000,
        null,
        null,
        "Success"
      );
      dispatch(
        clearRedux("ROLE", {
          roleSelected: null,
          loadedRecord: false,
        })
      );
      onClose(true);
    }
  }, [loadedRecord]);

  useEffect(() => {
    filterModules();
    if (categoriesModules) {
      if (changeRoleCustom) {
        setIsSupervisor(changeRoleCustom?.isSupervisor)
        setFormData(changeRoleCustom);
        if (changeRoleCustom.modules?.length) filterModules(changeRoleCustom);
      } else if (roleSelected) {
        setFormData({
          name: roleSelected.name,
        });
        setIsSupervisor(roleSelected?.isSupervisor)
        filterModules(roleSelected);
      }
    }
  }, [categoriesModules, roleSelected, changeRoleCustom]);

  useEffect(() => {
    if (moduleSelected) {
      switchModals();
    }
  }, [moduleSelected]);

  useEffect(() => {
    setShowModalCrud(onShow);
  }, [onShow]);

  useEffect(() => {
    if (role) {
      dispatch(getRole({ id: role.id }));
    }
  }, [role]);

  useEffect(() => {
    if(loadingSubUser || !subUserSelected) return
    const subUserRole = subUserSelected?.roleId || subUserSelected?.customRoleId
    let expiredUser = false
    const validateDate = moment(subUserSelected?.expiration).isBefore(moment())
    if(validateDate && subUserSelected?.expiration !== '0000-00-00'){
      expiredUser = true
    }
    if(subUserRole === role?.id || expiredUser) return setIsHideSupervisor(true)
    
  }, [subUserSelected, loadingSubUser])

  return (
    <Fragment>
      <Modal
        title={`${
          changeRoleCustom
            ? messages["role_custom"]
            : role
            ? `${messages["role_edit"]} ${role.name}`
            : messages["role_create"]
        }`}
        open={showModalCrud}
        size="small"
        handleClose={() =>
          changeRoleCustom ? onCloseCustomRole() : handleClose()
        }
        position="right"
        loading={loading || loadingModule || loadingGetRole || loadingCurrentSubUser}
      >
        <ModalBody>
          <div style={{ padding: 24, paddingBottom: 40 }}>
            <Form ref={formRef} onValidSubmit={() => consolidateData()}>
              <Grid
                container
                justifyContent={"center"}
                direction={"column"}
                className="paddingBody"
                spacing={2}
              >
                {!changeRoleCustom && (
                  <Grid item sm={12}>
                    <Box mb={3}>
                      <Input
                        id="username"
                        type="text"
                        label={messages["role_label"]}
                        placeholder={messages["role_label"]}
                        value={formData?.name || ""}
                        onChange={(value) =>
                          setFormData({
                            name: value,
                          })
                        }
                        disabled={changeRoleCustom}
                        minLength={2}
                        minLengthMessage={`${messages["role_minMessageUserType"]} 2`}
                        maxLength={50}
                        maxLengthMessage={`${messages["role_maxMessageUserType"]} 50`}
                        required
                        requiredMessage={messages["required_field"]}
                      />
                    </Box>
                  </Grid>
                )}
                {modulesForCategory && (
                  <Grid item sm={12}>
                    {
                      !isHideSupervisor && useSupervisorPermission(user, currentSubUser) &&
                      <Supervisor 
                        value={isSupervisor}
                        setValue={setIsSupervisor}
                        subUserSelected={subUserSelected}
                      />
                    }
                    <Modules
                      modulesList={[
                        ...modulesForCategory.permission,
                        ...modulesForCategory.report,
                      ]}
                      moduleSelected={(module) => setModuleSelected(module)}
                      savePermissions={(modules) => {
                        // Split updated modules back into their categories
                        setModulesForCategory({
                          ...modulesForCategory,
                          permission: modules.filter(
                            (m) => m.category === "Permission"
                          ),
                          report: modules.filter(
                            (m) => m.category === "Report"
                          ),
                        });
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          {changeRoleCustom ? (
            <Button onClick={() => onCloseCustomRole()} className="btn-cancel">
              {messages["back"]}
            </Button>
          ) : (
            <Button onClick={() => handleClose()} className="btn-cancel">
              {messages["cancel"]}
            </Button>
          )}
          {!changeRoleCustom && (
            <Button
              className="btn-blue"
              onClick={(e) => {
                e.preventDefault();
                formRef.current.submit();
              }}
            >
              {messages[`save`]}
            </Button>
          )}
        </ModalFooter>
      </Modal>
      {showModalSubModules && moduleSelected && (
        <SubModules
          onShow={showModalSubModules}
          handleClose={(module) => {
            setModuleSelected(module);
            let resultList = [
              ...modulesForCategory.permission,
              ...modulesForCategory.report,
            ];
            resultList[moduleSelected.index].checked = module.checked;
            // Copy subModules to persist checkbox changes made in the SubModules modal.
            // Without this, changes to individual subModule checkboxes are lost when
            // the modal closes, causing the saved role to have incorrect permissions.
            resultList[moduleSelected.index].subModules = module.subModules;
            setModulesForCategory({
              permission: resultList.filter(
                (modules) => modules.category === "Permission"
              ),
              report: resultList.filter(
                (modules) => modules.category === "Report"
              ),
            });
          }}
          module={moduleSelected.item}
        />
      )}
    </Fragment>
  );
};

export default CreditEditRol;